import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import heCommon from './locales/he/common.json';
import heNavigation from './locales/he/navigation.json';
import heHome from './locales/he/home.json';
import heAbout from './locales/he/about.json';
import heContact from './locales/he/contact.json';
import heServices from './locales/he/services.json';
import heTrainings from './locales/he/trainings.json';
import heBlog from './locales/he/blog.json';
import heIndustries from './locales/he/industries.json';
import heServicesPages from './locales/he/services-pages.json';
import heTrainingPages from './locales/he/training-pages.json';
import heConsulting from './locales/he/consulting.json';

import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enHome from './locales/en/home.json';
import enAbout from './locales/en/about.json';
import enContact from './locales/en/contact.json';
import enServices from './locales/en/services.json';
import enTrainings from './locales/en/trainings.json';
import enBlog from './locales/en/blog.json';
import enIndustries from './locales/en/industries.json';
import enServicesPages from './locales/en/services-pages.json';
import enTrainingPages from './locales/en/training-pages.json';
import enConsulting from './locales/en/consulting.json';

const resources = {
  he: {
    common: heCommon,
    navigation: heNavigation,
    home: heHome,
    about: heAbout,
    contact: heContact,
    services: heServices,
    trainings: heTrainings,
    blog: heBlog,
    industries: heIndustries,
    'services-pages': heServicesPages,
    'training-pages': heTrainingPages,
    consulting: heConsulting,
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    home: enHome,
    about: enAbout,
    contact: enContact,
    services: enServices,
    trainings: enTrainings,
    blog: enBlog,
    industries: enIndustries,
    'services-pages': enServicesPages,
    'training-pages': enTrainingPages,
    consulting: enConsulting,
  },
};

// Ensure Hebrew is default if no language is stored
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'he');
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'he',
    fallbackLng: 'he',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'home', 'about', 'contact', 'services', 'trainings', 'blog', 'industries', 'services-pages', 'training-pages', 'consulting'],
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;